import React, { useContext, useState } from "react";
import { authorizedBcba } from "../../utils/Definitions";
import { GlobalContext } from "../../utils/GlobalContext";
import Select, { components } from "react-select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";

interface Props {
    bcba: authorizedBcba;
    noLearnerInfo: boolean;
    UpdateAuthBCBA: (bcba: authorizedBcba) => void;
    OnClickDeleteAuth: (bcba: authorizedBcba) => void;
}

export const EDPNAuthBCBA: React.FC<Props> = (props) => {

    const globalContext = useContext(GlobalContext);
    const [tempStart, setTempStart] = useState<Date | null>(
        props.bcba.effectiveStart ? new Date(props.bcba.effectiveStart) : null
    );

    return (
        <div className="grid grid-cols-3 gap-1 mt-2">
            <label className="block font-bold">Authorized Provider:</label>
            <label className="block font-bold">Start Date:</label>
            <div></div>

            <Select
                isDisabled={props.noLearnerInfo}
                components={{ ValueContainer: components.ValueContainer }}
                isMulti={false}
                closeMenuOnSelect={true}
                options={globalContext.bcbas.map((therapist) => ({
                    value: String(therapist.therapistId),
                    label: therapist.employeeName
                }))}
                onChange={(newValue: any) => {
                    if (newValue) {
                        props.UpdateAuthBCBA({
                            ...props.bcba,
                            therapistId: Number(newValue.value)
                        });
                    }
                }}
                value={{
                    value: String(globalContext.bcbas.find(x => x.therapistId === props.bcba.therapistId)?.therapistId) || "",
                    label: globalContext.bcbas.find(x => x.therapistId === props.bcba.therapistId)?.employeeName || ""
                }}
            />

            <DatePicker
                disabled={props.noLearnerInfo}
                value={tempStart}
                onChange={(newValue) => setTempStart(newValue)}
                onAccept={(newValue) => {
                    if (newValue) {  // ensure non-null
                        props.UpdateAuthBCBA({
                            ...props.bcba,
                            effectiveStart: newValue
                        });
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        size="small"
                        onBlur={() => {
                            if (
                                tempStart &&
                                tempStart.toISOString() !== new Date(props.bcba.effectiveStart).toISOString()
                            ) {
                                props.UpdateAuthBCBA({
                                    ...props.bcba,
                                    effectiveStart: tempStart
                                });
                            }
                        }}
                    />
                )}
            />

            <button
                disabled={props.noLearnerInfo}
                onClick={() => props.OnClickDeleteAuth(props.bcba)}
                className={
                    "bg-rose m-auto w-[8rem] xl:w-[8rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-rose-600 " +
                    (props.noLearnerInfo ? "bg-rose-600" : "")
                }
            >
                <span className="drop-shadow">Delete</span>
            </button>
        </div>
    );
};
